import type { FiltersValues } from '@repo/go-widgets/filters';

import { hasValue } from 'src/packages/shared/utils/common';

import type { TFilterState } from './types';

const FILTERS_VALUES_TO_FILTER_STATE_KEYS: Array<{
  from: keyof FiltersValues;
  to: string;
}> = [
  { from: 'status', to: 'status' },
  { from: 'organizationId', to: 'organizationId' },
  { from: 'blockId', to: 'blockId' },
  { from: 'fieldId', to: 'fieldId' },
  { from: 'padId', to: 'padId' },
  { from: 'wellId', to: 'id' },
  { from: 'rigModelId', to: 'rigModelId' },
  { from: 'brigadeId', to: 'brigadeId' },
  { from: 'workStartDateFrom', to: 'workStartDateFrom' },
  { from: 'workStartDateTo', to: 'workStartDateTo' },
];

export function filtersValuesToFilterState(values: FiltersValues): TFilterState {
  const state: TFilterState = [];

  for (const { from, to } of FILTERS_VALUES_TO_FILTER_STATE_KEYS) {
    const value = values[from];

    if (!hasValue(value)) {
      continue;
    }

    if (Array.isArray(value) && value.length === 0) {
      continue;
    }

    state.push({
      name: to,
      value,
    });
  }

  return state;
}

export function isFilterStateEmpty(state: TFilterState | null | undefined): boolean {
  if (!state?.length) {
    return true;
  }

  return state.every(({ value }) => !hasValue(value));
}
